import React from "react";
import { Container } from "react-bootstrap";

export function AboutSection() {
  return (
    <section id="about" className="my-7">
      <Container
        style={{
          background: "#f8ffff",
          padding: "2rem",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        }}
      >
        <h2 className="text-center mb-4 text-cyan-pastel">Sobre Nosotros</h2>
        <p className="text-muted">
          Sanus Esthetic nació con el propósito de brindar bienestar, belleza y
          cuidado profesional a nuestros pacientes. Con más de 15 años de
          experiencia en tratamientos postquirúrgicos y estética avanzada, nos
          comprometemos a ofrecer atención personalizada, tecnología de punta y
          una experiencia única en cada sesión.
        </p>
      </Container>
    </section>
  );
}

export function PrivacySection() {
  return (
    <section id="privacy" className="my-5 py-5">
      <Container
        style={{
          background: "#f8ffff",
          padding: "2rem",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        }}
      >
        <h2 className="text-center mb-4 text-cyan-pastel">
          Política de Privacidad-Terminos y Condiciones
        </h2>
        <p className="text-muted">
          En cumplimiento de la Ley 1581 de 2012 de Protección de Datos
          Personales, informamos que los datos recopilados serán utilizados
          exclusivamente para fines informativos y comerciales relacionados con
          nuestros servicios. El titular de los datos tiene derecho a conocer,
          actualizar, rectificar y eliminar la información suministrada. Al
          utilizar nuestros servicios, aceptas cumplir con los términos y
          condiciones establecidos. Nos reservamos el derecho de modificar estos
          términos en cualquier momento. Es responsabilidad del usuario revisar
          periódicamente los cambios.
        </p>
      </Container>
    </section>
  );
}
